var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSylized3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.425781 10.9046C0.425781 4.88216 5.30767 3.24249e-05 11.3307 3.24249e-05C17.3524 3.24249e-05 22.2343 4.88216 22.2343 10.9046C22.2343 16.9269 17.3524 21.809 11.3307 21.809C5.30767 21.809 0.425781 16.9269 0.425781 10.9046Z",
    fill: "#F1B052"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11738 8.87557C8.11738 9.62346 7.75661 10.2299 7.31269 10.2299C6.87004 10.2299 6.50928 9.62346 6.50928 8.87557C6.50928 8.12768 6.87004 7.52116 7.31269 7.52116C7.75661 7.52116 8.11738 8.12768 8.11738 8.87557Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1513 8.87557C16.1513 9.62346 15.7918 10.2299 15.3479 10.2299C14.9039 10.2299 14.5444 9.62346 14.5444 8.87557C14.5444 8.12768 14.9039 7.52116 15.3479 7.52116C15.7918 7.52116 16.1513 8.12768 16.1513 8.87557Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42578 15.5002C9.92578 14.0001 12.4258 14.0001 13.9258 15.5001",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSylized3);
export default __webpack_public_path__ + "static/media/sylized_3.4290ea24b4e47b2fd3dd72ea1d3a6032.svg";
export { ForwardRef as ReactComponent };